// 拿到客户端提供的接口函数
const wpsQuery = window.cefQuery || window.wpsQuery
let Base64 = require('js-base64').Base64

// 判断是否是在WPS客户端内
const isWPSClient = typeof wpsQuery === 'function' && wpsQuery.toString() === 'function wpsQuery() { [native code] }'

// base64加密 Base64.encode
const _encode = function (data) {
  const str = typeof data === 'string' ? data : JSON.stringify(data)
  return Base64.encode(str)
}

// base64解密 Base64.decode 然后转为json
const _decode = function (data) {
  return JSON.parse(Base64.decode(data))
}

function isObject(value) {
  return Object.prototype.toString.call(value).toLowerCase() === '[object object]';
}

const callClientApi = function (param) {
  const paramStr = _encode(param)
  return wpsQuery({
    request: `fromJSAsynCallBase64("${paramStr}")`,
    persistent: false
  })
}

const SYSTEM_ERROR = new Error('system error')
const NOT_IN_CLIENT_ERROR = new Error('not in WPS client')

class PcSdk {
  constructor() {
    this.isWPSClient = isWPSClient;
    if (!isWPSClient) {
      console.warn('当前不在PC客户端内，sdk的方法将不会生效')
    }
  }
  encode(data) {
    return _encode(data)
  }
  decode(data) {
    return _decode(data)
  }

  /**
   * 使用系统默认浏览器打开外部链接，并且携带上自动登录信息
   * 原理是: 为会link生成一个id, 首先跳转至account.wps.com 带上这个id，登录成功后再解析这个id，拿到url, 进行跳转
   * @param {String} url
   * @param {Boolean} isInner
   */

  navigateOnNewWindow({ url, isInner }) {
    if (!isWPSClient) { return Promise.reject(NOT_IN_CLIENT_ERROR) }
    return new Promise((resolve, reject) => {
      window.navigateOnNewWindowCallback = function (resStr) {
        delete window.navigateOnNewWindowCallback
        const res = _decode(resStr) // res: {callstatus: "ok"}
        if (res.callstatus === 'ok') {
          resolve(res)
        } else {
          reject(SYSTEM_ERROR)
        }
      }
      callClientApi({
        method: 'navigateOnNewWindow',
        params: { url, isInner },
        callback: 'navigateOnNewWindowCallback'
      })
    })
  }

  openInnerUrl(link) {
    if (!isWPSClient) { return Promise.reject(NOT_IN_CLIENT_ERROR) }

    if (!link) {
      return;
    }

    return new Promise((resolve, reject) => {
      window.openInner = function (resStr) {
        delete window.openInner
        const res = _decode(resStr) // res: {callstatus: "ok"}
        if (res.callstatus === 'ok') {
          resolve(res)
        } else {
          reject(res.errormsg)
        }
      }
      callClientApi({
        method: 'common.util.openInnerUrl',
        params: { url: link },
        callback: 'openInner'
      })
    })
  }

  getCurSkin() {
    if (!isWPSClient) { return Promise.reject(NOT_IN_CLIENT_ERROR) }
    return new Promise((resolve, reject) => {
      window.getCurSkinCallback = function (resStr) {
        delete window.getCurSkinCallback
        const res = _decode(resStr)
        console.log(res, 'res===')
        if (res.callstatus === 'ok') {
          resolve(res)
        } else {
          reject(SYSTEM_ERROR)
        }
      }
      callClientApi({
        method: 'getCurSkin',
        callback: 'getCurSkinCallback'
      })
    })
  }

  /**
     * 调起登录框
     */
  login() {
    if (!isWPSClient) { return Promise.reject(NOT_IN_CLIENT_ERROR) }
    return new Promise((resolve, reject) => {
      window.login = resStr => {
        delete window.login;
        console.log('common.account.login');
        const res = _decode(resStr)
        if (res) resolve(res);
        else reject();
      };
      callClientApi({
        method: 'common.account.login',
        params: {
          "source": "|detailLoginSrc:help_center_favorites"
        },
        callback: 'login',
      });
    });
  }

  /**
     * 获取用户信息
     */
  getUserInfo() {
    if (!isWPSClient) { return Promise.reject(NOT_IN_CLIENT_ERROR) }
    return new Promise((resolve, reject) => {
      window.getUserInfo = resStr => {
        const res = _decode(resStr);
        delete window.getUserInfo;
        console.log(res, 'info');
        if (res) resolve(res);
        else reject();
      };
      callClientApi({
        method: 'common.account.getUserInfo',
        params: {},
        callback: 'getUserInfo',
      });
    });
  }

  /**
   * report，埋点
   */
  report(eventName, data) {
    if (!isWPSClient) { return Promise.reject(NOT_IN_CLIENT_ERROR) }
    let content = [];
    if (isObject(data)) {
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          content.push({ attribute: key, value: data[key] });
        }
      }
    }
    console.log(eventName, content);
    callClientApi({
      method: 'common.report.dataWarehouseSend',
      params: {
        eventName,
        content
      },
    });
  }

  // isOpenInLocalBrowser() {
  //   if (!isWPSClient) { return Promise.reject(NOT_IN_CLIENT_ERROR) }
  //   return new Promise((resolve, reject) => {
  //     window.getUserInfo = resStr => {
  //       const res = _decode(resStr);
  //       delete window.getUserInfo;
  //       console.log(res, 'info');
  //       if (res) resolve(res);
  //       else reject();
  //     };
  //     callClientApi({
  //       method: 'common.account.isOpenInLocalBrowser',
  //       params: {},
  //       callback: 'isOpenInLocalBrowser',
  //     });
  //   });
  // }

  /**
   * 打开端内容器
   * @param {*} url 
   * @returns 
   */
  navigateOnSingleWidget({ url }) {
    if (!isWPSClient) { return Promise.reject(NOT_IN_CLIENT_ERROR) };
    const params = {
      url,
      // width: '440',
      // height: '436',
      minWidth: '600', // TODO:
      minHeight: '636', // TODO:
      bNeesResize: 'true',
      closeBtn: 'false', // 自己实现关闭功能，因为端内的关闭比较丑
    };
    console.log(params);
    callClientApi({
      method: 'navigateOnSingleWidget',
      params,
    });
  }

  /**
   * 关闭端内容器
   * @param {*} url 
   * @returns 
   */
   closeWindow() {
    if (!isWPSClient) { return Promise.reject(NOT_IN_CLIENT_ERROR) };
    
    callClientApi({
      method: 'closeWindow',
      params: {},
    });
  }
  

  /**
   * 设置可拖拽区域
   * @param {*} url 
   * @returns 
   */
   setDragArea() {
    if (!isWPSClient) { return Promise.reject(NOT_IN_CLIENT_ERROR) };
    
    callClientApi({
      method: 'setDragArea',
      params: {
        width: '3000',
        height: '42'
      },
    });
  }

}

const sdk = new PcSdk()
export default sdk



// WEBPACK FOOTER //
// ./src/lib/sdk.js